import { getUIValidationRules } from '@dispatch/shared/services';
import { useQuery } from '../useQuery';
import { isEmpty } from 'lodash';

export const useGetUIValidationRules = (tenantId: string, enabled = true) => {
  const { data, status, refetch } = useQuery(
    ['claim-number-count-feature'],
    () => getUIValidationRules(tenantId),
    {
      enabled: enabled && !isEmpty(tenantId),
    }
  );

  return {
    feature: data,
    featureStatus: status,
    fetchFeature: refetch,
  };
};
